// company related APIs

import { useQuery } from 'react-query';
import { createFetchAPI } from '../http';
import { CompanyIdRequest } from './types';

const fetchCompanyDetails = createFetchAPI<
  CompanyIdRequest,
  FetchCompanyDetailsResponse
>();

export const useFetchCompanyDetails = ({ company_id }: CompanyIdRequest) =>
  useQuery<FetchCompanyDetailsResponse>(
    ['fetchCompanyDetails', { url: `v1/companies/${company_id}` }],
    fetchCompanyDetails,
  );

type FetchCompanyDetailsResponse = {
  id: number;
  name: string;
  fixed_fee: FixedFee;
  freemium_status: string;
  freemium_remaining_transactions: number;
  freemium_threshold: number;
  company_fpl_details: CompanyFPLDetail[];
};

type FixedFee = {
  percentage: number;
  effective_date: string;
  disabled_date: string;
  status: string;
  signature_date: string;
  signed_by: string;
  updated_at: string;
  updated_by: string;
};

type CompanyFPLDetail = {
  id: number;
  payment_method: number;
  status: string;
};
